/**
 * Stock Summary Cards Component
 */

import { Card, CardContent } from "@/components/ui/card";
import { Package, DollarSign, Calendar } from "lucide-react";
import { formatCurrency } from "@/lib/utils";
import type { StockItem } from "@/types/stock";

interface StockSummaryCardsProps {
  items: StockItem[];
  expiringItemsCount?: number;
}

export function StockSummaryCards({ items, expiringItemsCount = 0 }: StockSummaryCardsProps) {
  const totalProducts = items.length;
  
  const totalValue = items.reduce(
    (sum, item) => sum + Number(item.valor_total_estoque),
    0
  );

  const cards = [
    {
      title: "Total de Produtos",
      value: totalProducts.toString(),
      icon: Package,
      color: "text-primary",
    },
    {
      title: "Valor Total do Estoque",
      value: formatCurrency(totalValue),
      icon: DollarSign,
      color: "text-success",
    },
    {
      title: "Próximos do Vencimento",
      value: expiringItemsCount.toString(),
      icon: Calendar,
      color: "text-orange-500",
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-3">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  {card.title}
                </p>
                <p className="text-2xl font-bold mt-2">{card.value}</p>
              </div>
              <card.icon className={`h-8 w-8 ${card.color}`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
